// 司机审核状态枚举
export const driverStatusEnum = {
  '0': '待提交',
  '1': '审核中',
  '11': '系统审核驳回',
  '2': '待补充资料',
  '3': '待人工审核',
  '13': '人工审核驳回',
  '4': '审核通过',
  '-1': '已拒绝'
}
// 招募培训状态枚举
export const trainStatusEnum = {
  '1': '未推送',
  '2': '未完成',
  '3': '已完成'
}
// 招募申请单主状态枚举
export const mainStatusEnum = {
  '1': '已注册',
  '2': '报名中',
  '3': '人工审核中',
  '4': '审核通过',
  '5': '待入驻',
  '6': '已入驻',
  '7': '已取消',
  '8': '已拒绝',
  '9': '异常'
}
// 车辆审核状态枚举
export const vehicleStatusEnum = {
  '0': '已新建',
  '1': '待审核',
  '2': '审核通过',
  '3': '审核退回',
  '4': '审核未通过',
  '5': '已删除',
  '6': '待系统审核',
  '7': '审核通过未添加车辆'
}
// 系统/人工审核状态枚举
export const checkStatusEnum = {
  '1': '通过',
  '2': '驳回',
  '3': '拒绝'
}

export const driverStatuSteps = {
  '系统审核驳回': {
    title: '提交审核资料',
    statusText: '个人资料审核驳回',
    fail: true,
    showFailHeader: true,
    btnText: '修改驳回资料'
  },
  '人工审核驳回': {
    title: '提交审核资料',
    statusText: '个人资料审核驳回',
    fail: true,
    showFailHeader: true,
    btnText: '修改驳回资料'
  },
  '待人工审核': {
    title: '提交审核资料',
    statusText: '个人资料审核中',
    tip: '审核结果将短信通知'
  },
  '审核通过': {
    title: '提交审核资料',
    statusText: '个人资料审核通过',
    active: true
  }
}